import { IDoPos, IPitch, IParsedDo } from "../../../../../../../common/types";

export const getAbcName = (tone: IPitch, _do: IDoPos, octave: number) => {
    if (tone.s === undefined) return "";
    let pitch = ABCvalues[tone.s] + ((tone.o || 0) + octave) * 7;
    const doPos = parseDo(_do);
    pitch += doPos.value;
    let alt = getABCalt(tone.s, _do) + (tone.a || 0);
    let ABC = (dos[dos.findIndex(a => a.value === pitch && a.alt === alt)] || { label: "?" }).label;
    return ABC;
};

const parseDo = (doPos: IDoPos): IParsedDo => {
    let value = (((doPos.i < 0 ? doPos.i + 14 : doPos.i) * 4) % 7) - 6;
    value += (doPos.o - 4) * 7;
    let alt = 0;
    if (doPos.i < -1) alt = -1;
    if (doPos.i > 5) alt = 1;
    return {
        value,
        alt,
    };
};

const ABCvalues = [3, 0, 4, 1, 5, 2, 6];

const getABCalt = (s: IPitch["s"], _do: IDoPos) => {
    let alt = 0;
    const key = _do.i;
    if (key + s > 6) alt = 1;
    else if (key + s < 0) alt = -1;
    return alt;
};

const dos: { label: string, value: number, alt: -2 | -1 | 0 | 1 | 2 }[] = [];

const abcs = ["c", "d", "e", "f", "g", "a", "h"];
const eszLetters = ["c", "d", "f", "g"];

const octaves = [1, 2, 3, 4, 5, 6];

octaves.forEach(octave => {
    abcs.forEach((abc, abcIndex) => {
        let casedAbc = abc;
        if (octave <= 2) casedAbc = abc.toUpperCase();
        let signs = "’’’".slice(0, Math.max(0, octave - 3))
        if (octave === 1) signs = ","

        dos.push({
            label: `${abc === "h" ? (octave <= 2 ? "B" : "b" ) : casedAbc}${eszLetters.includes(abc) ? "e" : ""}${abc === "h" ? "" : "sz"}${abc === "h" ? "ebé" : abc === "a" ? "asz" : "esz"}${signs}`,
            value: octave * 7 + abcIndex - 34,
            alt: -2,
        });
        dos.push({
            label: `${abc === "h" ? (octave <= 2 ? "B" : "b" ) : casedAbc}${eszLetters.includes(abc) ? "e" : ""}${abc === "h" ? "" : "sz"}${signs}`,
            value: octave * 7 + abcIndex - 34,
            alt: -1,
        });
        dos.push({
            label: `${casedAbc}${signs}`,
            value: octave * 7 + abcIndex - 34,
            alt: 0,
        });
        dos.push({
            label: `${casedAbc}isz${signs}`,
            value: octave * 7 + abcIndex - 34,
            alt: 1,
        });
        dos.push({
            label: `${casedAbc}iszisz${signs}`,
            value: octave * 7 + abcIndex - 34,
            alt: 2,
        });
    })
});
